<template>
  <div id="app">
    <header class="header">
      <nav>
        <div class="container">
          <div class="content">
            <router-link class="logo" to="/">
              <img src="@/assets/logo.png" alt="Logo Zakotane Railway">
            </router-link>
            <nav class="main-nav">
              <ul>
                <li>
                  <router-link :to="linkToSearch">Wyszukaj połączenie</router-link>
                </li>
                <li v-if="userSignedIn">
                  <router-link to="/my-tickets">Moje bilety</router-link>
                </li>
                <li v-if="!userSignedIn">
                  <router-link to="/sign">Zaloguj | Zarejestruj</router-link>
                </li>
                <li v-if="userSignedIn" class="log-out">
                  <a @click="logOut">
                    <i class="fas fa-sign-out-alt"></i>Wyloguj
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </nav>
    </header>
    <main class="main">
      <router-view v-if="dataAvailable"/>
    </main>
    <AppFooter/>
  </div>
</template>

<script>
import AppFooter from './components/AppFooter.vue';

import storeMixins from './mixins/storeMixins';

export default {
  name: 'app',
  components: {
    AppFooter,
  },
  mixins: [storeMixins],
  created() {
    this.$store.dispatch('trainCategories/fetchFromServer');
    this.$store.dispatch('stations/fetchFromServer');
  },
  computed: {
    dataAvailable() {
      return (
        this.$store.state.trainCategories.list.length > 0
        && this.$store.state.stations.list.length > 0
      );
    },
    linkToSearch() {
      const searchRoutes = ['NewsFeed', 'SearchResults'];
      return {
        name: searchRoutes.includes(this.$route.name) ? '' : 'NewsFeed',
      };
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch('user/logOut');
      this.$router.push('/');
    },
  },
};
</script>

<style>
body {
  --container-width: 1200px;

  --color-main: #3f51b5;
  --color-hover: #6675c9;
  --color-second: #f1c40f;
}

body {
  margin: 0;
  padding: 0;
  background: #fff;
  font-family: 'Open Sans', sans-serif;
}

a {
  text-decoration: none;
  cursor: pointer;
}

* {
  box-sizing: border-box;
}

.container {
  max-width: var(--container-width);
  margin: 0 auto;
}

button {
  cursor: pointer;
  border: none;
  background-color: var(--color-main);
  color: #fff;
  transition: background-color 0.5s ease;
  padding: 10px 15px;
  border-radius: 4px;
}

button.upper {
  text-transform: uppercase;
}

button i:not(.nomargin) {
  margin-right: 10px;
}

button:hover {
  background-color: var(--color-hover);
}

button:focus {
  outline: none;
}

[hidden] {
  display: none;
}

.horz {
  display: flex;
  flex-direction: row;
}

.page-title {
  display: flex;
  justify-content: center;
  font-size: 35px;
  padding: 50px 0;
  margin: 0;
}

.background {
  background-image: url('assets/background/background.jpg');
  background-size: cover;
  background-position: center;
}
</style>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 50px;
  width: 100%;
  background-color: var(--color-main);
  z-index: 1;
}

.header .content {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.header .content .logo {
  line-height: 10px;
}

.header .content .logo img {
  height: 40px;
  margin-top: 5px;
}

.header .main-nav ul {
  display: flex;
  margin: 0 -30px 0 0;
  align-items: center;
}

.header .main-nav li {
  list-style: none;
}

.header .main-nav li a {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 0 30px;

  color: #fff;
  font-size: 15px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  transition: color 0.5s ease, background-color 0.5s ease;
}

.header .main-nav li:last-child a {
  border-right: none;
}

.header .main-nav li a:hover {
  color: var(--color-main);
  background-color: #fff;
}

.header .main-nav li.log-out i {
  padding-right: 5px;
}

.main {
  margin-top: 50px;
}
</style>
